
function maskAllButLast4Chars(str) {
  if (!str || str.length < 4) {
    return str;
  }

  return `XXXX${str.substring(str.length - 4)}`;
}

export default {
  data: {
    // Should hold display text for a payment account (payment reciept)
    selectedPayFrom: '',
    routingNumber: '',
    accountNumber: '',
    accountType: '',
  },
  computed: {
    payFromText() {
      if (this.selectedPayFrom) {
        return this.selectedPayFrom;
      }

      return `Routing ${this.maskedRoutingNumber} | ${this.accountType} ${this.maskedAccountNumber}`;
    },
    maskedRoutingNumber() {
      return maskAllButLast4Chars(this.routingNumber);
    },
    maskedAccountNumber() {
      return maskAllButLast4Chars(this.accountNumber);
    },
  },
  methods: {
    // An options list of payment accounts has masked account numbers and labels.
    // This method should be bound using v-on:change to handle updating the app's
    // payFromText value for display on a later step (payment reciept).
    getPayFrom(e) {
      if (e && e.target) {
        const selected = e.target.selectedOptions && e.target.selectedOptions.length && e.target.selectedOptions[0];
        if (selected && selected.text !== '' && selected.text !== 'Add New Bank Account') {
          this.selectedPayFrom = selected.text;
        } else {
          this.selectedPayFrom = null;
        }
        if (selected && selected.text !== '' && selected.text === 'Pay with a Credit/Debit Card, PayPal or Amazon Pay. Fees may apply.') {
          Event.$emit('A11yDialogOpen', { dialogKey: 'paymentus-one-time-message1' })
        }
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/bankAccount.js